export default __webpack_public_path__ + "static/media/rice05.9a5361ec.png";